import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useLocation } from "react-router-dom";
const tableHead = [
  "Sr.",
  "Employee name",
  "contact number",
  "Role In Organisation",
  "Reporting To",
  "Status",
  // "Experience Count",
  "Actions",
];

const tableHead2 = [
  "Sr.",
  "Employee name",
  "contact number",
  "Role In Organisation",
  "Status",
  "Left Date",
  // "Experience Count",
  "Actions",
];
const getStatus = (status) => {
  if (status === "leftOrganization") {
    return <span class="badge bg-red text-white">Left Organization</span>;
  }
  if (status === "onProbation") {
    return <span class="badge bg-yellow text-white">On Probation</span>;
  }
  if (status === "activePostion") {
    return <span class="badge bg-green text-white">Active Postion</span>;
  }
  if (status === "onBoarding") {
    return <span class="badge bg-purple text-white">Onboarding</span>;
  }
  if (status === "offBoarding") {
    return <span class="badge bg-orange text-white">Offboarding</span>;
  }
};

// const Experience = (joiningDate, leftDate = new Date()) => {
//   if (!joiningDate) return "N/A";
//   const joinDate = new Date(joiningDate);
//   const endDate = leftDate ? new Date(leftDate) : new Date();

//   let years = endDate.getFullYear() - joinDate.getFullYear();
//   let months = endDate.getMonth() - joinDate.getMonth();
//   let days = endDate.getDate() - joinDate.getDate();

//   if (months < 0 || (months === 0 && days < 0)) {
//     years--;
//     months += 12;
//   }

//   if (days < 0) {
//     const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
//     days += prevMonth.getDate();
//     months--;
//   }

//   const decimalExperience = years + months / 12;

//   return decimalExperience.toFixed(1);
// };

const AllEmployeeTable = ({ employees = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pathname, setpathName] = useState(location.pathname);
  const getName = (fname = "", lname = "") => {
    let bag = "";
    if (fname) {
      bag += fname;
    }
    if (lname) {
      bag += ` ${lname}`;
    }
    if (!bag) {
      bag = "N/A";
    }
    return bag;
  };
  const goToView = (id) => {
    navigate(`/employee-management/view-employee/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          {pathname !== "/employee-management/oldEmployee" ? (
            <tr>
              {tableHead?.map((item, index) => {
                return <th key={index}>{item}</th>;
              })}
            </tr>
          ) : (
            <tr>
              {tableHead2?.map((item, index) => {
                return <th key={index}>{item}</th>;
              })}
            </tr>
          )}
        </thead>
        <tbody>
          {employees?.map((employee, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={employee?.id}>
                <td>{Index}</td>
                <td>{getName(employee.firstName, employee.lastName)}</td>
                <td>{employee?.contactNumber || "N/A"}</td>
                <td>
                  {employee?.roleInOrganisation || "N/A"}
                  {employee?.isfreeLancer && <hr className="p-0 m-0"></hr>}
                  {employee?.isfreeLancer === "freeLancerStaff" && (
                    <span class="badge bg-info text-white mt-1 mb-1">
                      Freelancer
                    </span>
                  )}
                </td>

                {employee?.employeeStatus != "leftOrganization" && (
                  <td>{employee?.reportingToName || "N/A"}</td>
                )}
                {/* <td>{extractDate(employee?.createdAt) || "N/A"}</td> */}
                <td>{getStatus(employee?.employeeStatus) || "N/A"}</td>
                {employee?.employeeStatus == "leftOrganization" && (
                  <td>{employee?.leftOrganizationDate || "N/A"}</td>
                )}
                {/* <td>
                  {Experience(
                    employee?.dateOfJoining,
                    employee?.leftOrganizationDate
                  ) || "N/A"}{" "}
                  year
                </td> */}
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => goToView(employee.id)}
                  >
                    <BsArrowRightShort className="me-1" /> View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllEmployeeTable;
